import { IS_PRODUCTION } from "@app/config/getServiceUrl";
import { useSafeAreaInset } from "../SafeArea/useSafeAreaInset";

/**
 * Test / PR 서버에서만 빌드 정보를 표시한다.
 * Production 서버에서는 렌더링되지 않는다.
 *
 * 배포 후 모바일 PWA에서 DevTools 없이 현재 버전을 확인할 수 있도록 한다.
 * 표시 정보: git commit hash + 빌드 시각
 */
export function BuildVersionBadge() {
  if (IS_PRODUCTION) {
    return null;
  }

  return <BadgeContent />;
}

function BadgeContent() {
  const buildTime = formatBuildTime(__BUILD_TIME__);
  const { bottom } = useSafeAreaInset();

  return (
    <div
      aria-label="Build version info"
      className="fixed left-4 z-[9998] flex items-center gap-1.5 rounded-full bg-black/60 px-2.5 py-1 backdrop-blur-sm"
      style={{ bottom: `calc(1rem + ${bottom}px)` }}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
      <span className="font-mono text-[10px] leading-none text-white/70">
        {__BUILD_HASH__} · {buildTime}
      </span>
    </div>
  );
}

function formatBuildTime(iso: string): string {
  try {
    const date = new Date(iso);
    const MM = String(date.getMonth() + 1).padStart(2, "0");
    const DD = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    return `${MM}/${DD} ${hh}:${mm}`;
  } catch {
    return iso;
  }
}
